(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brain-memory"] && !Shopify.designMode) return;
  try {
    
(function () {
  var pages = document.querySelectorAll('.bm-page');
  if (!pages.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  pages.forEach(function (page) {
    page.classList.add('bm-js');
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('bm-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    page.querySelectorAll('.bm-reveal').forEach(function (el) { io.observe(el); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-close"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el){el.classList.add('is-in');}); return; }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-credentials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el){el.classList.add('is-in');}); return; }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-empower"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el){el.classList.add('is-in');}); return; }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-formulas-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-give-back"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el){el.classList.add('is-in');}); return; }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-kirtan"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-research"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drd-teachings"] && !Shopify.designMode) return;
  try {
    
(function () {
  function drdScan() {
    var els = document.querySelectorAll('.drd-rv:not(.is-in)');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!window.drdRevealIO) {
      window.drdRevealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); window.drdRevealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { window.drdRevealIO.observe(el); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', drdScan); } else { drdScan(); }
  document.addEventListener('shopify:section:load', drdScan);
})();

  } catch(e) { console.error(e); }
})();
})();
